import { computed } from 'mobx';

/**
 * 모델
 * @window w_pz010
 * @category 휴일등록
 */
export class HolidayCodeModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 휴일일자(시작)
   *
   * **data type** varchar(8)
   */
  holiday: string;

  /**
   * 비고
   *
   * **data type** varchar(50)
   */
  remarks: string;

  /**
   * 휴일구분
   *
   * **data type** varchar(1)
   */
  holiflag: string;

  /**
   * 휴일일자(끝)
   *
   * **data type** varchar(8)
   */
  holiday2: string;

  /**
   * 기간
   *
   * **data type** decimal(3, 1)
   */
  daynum: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.holiday = data.holiday || '';
    this.remarks = data.remarks || '';
    this.holiflag = data.holiflag || '';
    this.holiday2 = data.holiday2 || '';
    this.daynum = data.daynum || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
